import { Icon } from "semantic-ui-react";

import useWindowSize from "react-use/lib/useWindowSize";

import Flex from "../../../../../components/Flex/Flex";
import themeColors from "../../../../ui/constants/themeColors";

function getColor({ activeNumber, number, last }) {
	// Active / Blue
	if (activeNumber === number && !last) {
		return {
			color: themeColors.BLUE,
			backgroundColor: "var(--color-blue-faded)",
		};
	}

	// Inactive / Grey
	if (activeNumber < number) {
		return {
			color: themeColors.GREY,
			backgroundColor: "var(--color-grey-faded)",
		};
	}

	// Completed / Green
	return {
		color: themeColors.GREEN,
		backgroundColor: "var(--color-green-faded)",
	};
}

export default function ProductionStatusLadderStep({ step, number, activeNumber, last, onClick }) {
	const { width } = useWindowSize();

	const desktop = width > 600;

	const circleSize = 35;
	const lineWidth = 4;

	const { color, backgroundColor } = getColor({ activeNumber, number: number, last });

	const { backgroundColor: previousStepBackgroundColor } = getColor({ activeNumber, number: number - 1 });

	const opacity = activeNumber >= number ? 1 : 0.3;

	return (
		<Flex
			flexDirection="column"
			gap={10}
			style={{
				position: "relative",
			}}
		>
			{number > 1 && (
				<div
					style={{
						position: "absolute",
						top: circleSize / 2,
						left: 0,
						width: `calc(100% - ${circleSize}px)`,
						height: lineWidth,
						transform: `translate(-50%, -50%)`,
						backgroundColor,
						backgroundImage:
							number === activeNumber &&
							`linear-gradient(to right, ${previousStepBackgroundColor} 0%, ${backgroundColor} 100%)`,
						opacity,
					}}
				/>
			)}

			<Flex
				justifyContent="center"
				style={{
					color,
					height: circleSize,
					width: circleSize,
					backgroundColor,
					opacity: activeNumber >= number ? 1 : 0.3,
					borderRadius: "50%",
					flexShrink: 0,
				}}
				onClick={onClick}
			>
				{activeNumber > number || last ? (
					<div>
						<Icon name="check" style={{ margin: 0 }} />
					</div>
				) : (
					<div>{number}</div>
				)}
			</Flex>

			<p>&nbsp;{(desktop || activeNumber === number) && step.text}&nbsp;</p>
		</Flex>
	);
}
